<div class="tvd-bucket flex flex-col h-full bg-white border-solid  rounded-[18px] md:w-80 xl:min-w-96" 
    [ngClass]="(selectedItem && makingSelectionsState) ? 'border-2 border-blue' : 'border-1 border-sky-blue'"
>

    <div class="tvd-container flex flex-col grow">
        <div class="tvd-container-header flex items-center justify-between min-h-10 px-6 py-4"
            [ngClass]="(selectedItem && makingSelectionsState) ? 'neptune-border-b-2 border-blue' : 'neptune-border-b-1 border-sky-blue'"
        >
            <div class="tvd-title flex gap-2 items-center">
                <img src="{{pngPath}}" class="w-9 h-9" alt="tvd-metric-icon">
                <div id="box-text" class="flex items-center text-blue text-2xl min-h-2xl-clamp">{{custTileTitle}}</div>
            </div>
        </div>

        <div class="tvd-container-body flex flex-col grow gap-3 p-6">
            <div class="tvd-contribution flex flex-col grow gap-4">
                <div class="tvd-monetary-contribution flex">
                    <span class="font-bold text-4xl">{{costCurrencyCode | currencySymbol}}{{displayInRoundedNumber ? (custTileCost | abbreviateNumber) : custTileCost}}</span>
                </div>
                
                <div class="tvd-value-contribution flex">
                        <p class="text-base"><span class="font-bold">{{custTileValue}}</span> {{custTileUnit}}</p>
                </div>

                <ng-container *ngIf="addedToPres">
                    <div class="added-indicator text-neptune-neutral px-4 py-2 text-sm rounded-md bg-mocassin bg-opacity-60 w-max font-medium">Added</div>
                </ng-container>
            </div>

            <ng-container *ngIf="makingSelectionsState; else editCustomTileButton">
                <button id="{{custTileTitle}}" class="add-tile-to-presentation flex justify-center items-center px-3 py-2 " 
                    [ngClass]="{ 'neptune-button-blue': selectedItem,
                        'neptune-button-white': !selectedItem,
                        'cursor-not-allowed': disableSelectionButton,
                        'cursor-pointer': !disableSelectionButton }" 
                    (click)="toggleSelectItem(custTileTitle)"
                    >
                    <ng-container *ngIf="!selectedItem; else resetSelection">
                        <span class="text-sm">Add</span>
                        <img src="assets/shared-icons/neptune-icon-blue-plus-sign.svg" *ngIf="!selectedItem" class="w-5 h-5" alt="plus-icon" />
                    </ng-container>
                    <ng-template #resetSelection>
                        <span class="text-sm">Added</span>    
                        <img src="assets/shared-icons/neptune-icon-white-tick.svg" *ngIf="selectedItem" class="w-5 h-5" alt="tick-icon" />
                    </ng-template>
                </button>
            </ng-container>
            <ng-template #editCustomTileButton>
                <div class="edit-custom-tile-button neptune-button-white flex justify-center items-center px-3 py-2 cursor-pointer" (click)="editCustomTile()">
                    Edit Custom Tile 
                    <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" class="h-5 w-5" alt="arrow-right-icon"/>
                </div>
            </ng-template>
        </div>

        
    </div>

</div>
